<template>
  <div
    class="flex flex-row gap-2 p-4 bg-surface"
    :class="{ 'rounded-3xl': !channelStore.isAsMonacoFanToken }"
  >
    <!-- Avatar column -->
    <div class="flex flex-col items-center">
      <Skeleton width="32px" height="32px" border-radius="50%" />

      <!-- Thread line -->
      <div
        class="flex-1 w-[1px] mt-1 mb-8 rounded-full from-fill-brand-secondary to-transparent bg-gradient-to-b"
      />
    </div>

    <!-- Content column -->
    <div class="flex flex-col gap-1 flex-grow">
      <!-- Header with username and time -->
      <div class="flex justify-between items-start">
        <div class="flex gap-2 items-center">
          <!-- Username -->
          <Skeleton
            :width="usernameWidths[index % usernameWidths.length]"
            height="20px"
            border-radius="4px"
          />
          <!-- Country badge -->
          <Skeleton width="24px" height="16px" border-radius="4px" />
        </div>

        <div class="flex items-center justify-center gap-3">
          <!-- Time -->
          <Skeleton width="60px" height="16px" border-radius="4px" />
          <!-- Menu dots -->
          <Skeleton width="24px" height="24px" border-radius="4px" />
        </div>
      </div>

      <!-- Thread content -->
      <div class="flex flex-col gap-2">
        <Skeleton
          :width="contentWidths[index % contentWidths.length]"
          height="16px"
          border-radius="4px"
        />
        <Skeleton
          v-if="index % 2 === 0"
          :width="secondLineWidths[index % secondLineWidths.length]"
          height="16px"
          border-radius="4px"
        />
      </div>

      <!-- Media skeleton (occasionally) -->
      <div v-if="index % 4 === 1" class="w-64 mt-2">
        <Skeleton width="256px" height="144px" border-radius="12px" />
      </div>

      <!-- Action buttons -->
      <div class="flex items-center gap-3 text-text mt-3">
        <!-- Like button -->
        <div class="flex flex-col gap-1 items-center justify-center">
          <Skeleton width="32px" height="32px" border-radius="4px" />
          <Skeleton width="20px" height="16px" border-radius="4px" />
        </div>

        <!-- Comment button -->
        <div class="flex flex-col gap-1 items-center justify-center">
          <Skeleton width="32px" height="32px" border-radius="4px" />
          <Skeleton width="20px" height="16px" border-radius="4px" />
        </div>

        <!-- Share button -->
        <div class="ml-auto flex flex-col items-center justify-between gap-2.5">
          <Skeleton width="32px" height="32px" border-radius="4px" />
          <Skeleton width="40px" height="12px" border-radius="4px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";
import { useChannelStore } from "@/stores/channel.store";

const _props = withDefaults(
  defineProps<{
    index?: number;
  }>(),
  {
    index: 0,
  },
);

const channelStore = useChannelStore();

// Different widths for variety
const usernameWidths = ["120px", "90px", "140px", "100px"];
const contentWidths = ["80%", "90%", "70%", "85%"];
const secondLineWidths = ["60%", "70%", "50%", "65%"];
</script>
